import { InlineAlert } from '@eventbrite/marmalade';
import React from 'react';
import './ConfirmationNotification.scss';

export const ConfirmationNotification: React.FunctionComponent = () => {
    return (
        <div>
            <InlineAlert
                className="inline-alert_sorry-message-for-dislikes"
                description={"We won't suggest that event again."}
                title={'No Problem'}
            />
        </div>
    );
};
